import script from "./AvisolegalView.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisolegalView.vue?vue&type=script&setup=true&lang=js"

import "./AvisolegalView.vue?vue&type=style&index=0&id=a65074c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a65074c4"]])

export default __exports__